<div class="qr-page">

  <wr-qr-code-building-header active=""></wr-qr-code-building-header>

  @if (context.buildingInfo(); as info) {

    <!-- Building info -->
    <div class="info-card">

      <!-- Eigentümer -->
      @if (info.ownerTenantName || info.ownerTenantPhone) {
        <div class="info-group">
          <span class="info-label">Eigentümer</span>
          <div class="info-group-body">
            @if (info.ownerTenantName) {
              <span class="info-value">{{ info.ownerTenantName }}</span>
            }
            @if (info.ownerTenantPhone) {
              <a class="info-value info-link" [href]="'tel:' + info.ownerTenantPhone">
                <nb-icon icon="phone-outline" pack="eva"></nb-icon>
                {{ info.ownerTenantPhone }}
              </a>
            }
          </div>
        </div>
      }

      <!-- Kunde -->
      @if (info.propertyManagerName || info.propertyManagerEmail || info.propertyManagerPhone) {
        <div class="info-group">
          <span class="info-label">Kunde</span>
          <div class="info-group-body">
            @if (info.propertyManagerName) {
              <span class="info-value">
                <nb-icon icon="person-outline" pack="eva"></nb-icon>
                {{ info.propertyManagerName }}
              </span>
            }
            @if (info.propertyManagerEmail) {
              <a class="info-value info-link" [href]="'mailto:' + info.propertyManagerEmail">
                <nb-icon icon="email-outline" pack="eva"></nb-icon>
                {{ info.propertyManagerEmail }}
              </a>
            }
            @if (info.propertyManagerPhone) {
              <a class="info-value info-link" [href]="'tel:' + info.propertyManagerPhone">
                <nb-icon icon="phone-outline" pack="eva"></nb-icon>
                {{ info.propertyManagerPhone }}
              </a>
            }
          </div>
        </div>
      }

      <!-- Identifikation -->
      @if (info.externalNumber || info.buildingZipCode) {
        <div class="info-group">
          <span class="info-label">Identifikation</span>
          <div class="info-group-body">
            @if (info.externalNumber) {
              <div class="info-pair">
                <span class="info-sublabel">Objektnummer extern</span>
                <span class="info-value">{{ info.externalNumber }}</span>
              </div>
            }
            @if (info.buildingZipCode) {
              <div class="info-pair">
                <span class="info-sublabel">PLZ</span>
                <span class="info-value">{{ info.buildingZipCode }}</span>
              </div>
            }
          </div>
        </div>
      }

      <!-- Zugang -->
      @if (info.propertyKey || info.keySafeWithPosition || info.codes) {
        <div class="info-group">
          <span class="info-label">Zugang</span>
          <div class="info-group-body">
            @if (info.propertyKey) {
              <div class="info-pair">
                <span class="info-sublabel">Schlüssel</span>
                <span class="info-value">{{ info.propertyKey }}</span>
              </div>
            }
            @if (info.keySafeWithPosition) {
              <div class="info-pair">
                <span class="info-sublabel">Schlüsselsafe mit Position</span>
                <span class="info-value">{{ info.keySafeWithPosition }}</span>
              </div>
            }
            @if (info.codes) {
              <div class="info-pair">
                <span class="info-sublabel">Codes</span>
                <span class="info-value">{{ info.codes }}</span>
              </div>
            }
          </div>
        </div>
      }

      <!-- Gebäude -->
      @if ((info.entryCount !== null && info.entryCount !== undefined) || info.buildingSections.length) {
        <div class="info-group">
          <span class="info-label">Gebäude</span>
          <div class="info-group-body">
            @if (info.entryCount !== null && info.entryCount !== undefined) {
              <div class="info-pair">
                <span class="info-sublabel">Anzahl Eingänge</span>
                <span class="info-value">{{ info.entryCount }}</span>
              </div>
            }
            @if (info.buildingSections.length) {
              <div class="info-pair">
                <span class="info-sublabel">Adressen</span>
                @for (section of info.buildingSections; track $index) {
                  <span class="info-value">{{ section.buildingSectionAddress }}</span>
                }
              </div>
            }
          </div>
        </div>
      }

      <!-- Teams -->
      @if (info.teams.length) {
        <div class="info-group">
          <span class="info-label">Teams</span>
          <div class="info-group-body">
            @for (team of info.teams; track $index) {
              <span class="info-value">{{ team }}</span>
            }
          </div>
        </div>
      }

    </div>

    <!-- Building sections -->
    @if (info.buildingSections.length) {
      <div class="section-header">
        <span class="section-title">Gebäudeabschnitte</span>
        <span class="section-count">{{ info.buildingSections.length }}</span>
      </div>

      <div class="section-list">
        @for (section of info.buildingSections; track section.id) {
          <button class="section-item" data-cy="qr-building-section" (click)="goToSection(section)">
            <div class="section-item-left">
              <nb-icon icon="map-outline" pack="eva" class="section-icon"></nb-icon>
              <span class="section-address">{{ section.buildingSectionAddress }}</span>
            </div>
            <nb-icon icon="arrow-ios-forward-outline" pack="eva" class="section-chevron"></nb-icon>
          </button>
        }
      </div>
    }

  } @else {
    <div class="loading-state">
      <nb-spinner status="primary"></nb-spinner>
    </div>
  }

</div>
